<!--
  closable=false: o close() do PrimeNG (X, ESC, máscara) esconde o dialog antes de avisar, sem
  hook cancelável, então um formulário sujo perdia a confirmação de descarte. X, ESC e clique na
  máscara são tratados pelo componente e passam pelo cancel().
-->
<p-dialog [visible]="visible" (visibleChange)="onVisibleChange($event)" [modal]="true" [draggable]="false"
  [resizable]="false" [closable]="false"
  [style]="{ width: '900px', maxWidth: '96vw' }" position="top" styleClass="os-create-dialog" maskStyleClass="os-dialog-mask">

  <ng-template #header>
    <div class="os-dialog-header">
      <div class="os-dialog-heading">
        <h2 class="os-dialog-title">{{ 'service-order.create-form-title' | translate }}</h2>
        <p class="os-dialog-subtitle">{{ 'service-order.create-form-hint' | translate }}</p>
      </div>
      <button type="button" class="os-head-close" (click)="cancel()"
        [attr.aria-label]="'service-order.close-dialog-label' | translate">
        <i class="pi pi-times"></i>
      </button>
    </div>
  </ng-template>

  <!--
    Enum vira <select> nativo (mesmo padrão da tela de import de OS): o popup é do SO, então
    não disputa z-index nem rola o conteúdo do modal como o overlay do p-select fazia.
    Os autocompletes seguem com appendTo="body" pelo mesmo motivo.
  -->
  <!--
    Marca inválido por `dirty` e não `touched`: o p-dialog dá foco no primeiro campo ao abrir,
    então com `touched` o formulário nascia com dois campos em vermelho. É também a convenção
    do próprio PrimeNG (.ng-invalid.ng-dirty).
  -->
  <!-- Duas colunas: formulário à esquerda, painel da instalação escolhida à direita -->
  <div class="os-create-cols">
  <div class="os-dialog-body" [formGroup]="form">
    <div class="os-field-row">
      <div class="os-field">
        <label class="os-label" for="os-create-reference">{{ 'service-order.reference-label' | translate }}</label>
        <input pInputText class="w-full" id="os-create-reference" formControlName="reference" autocomplete="off"
            maxlength="30" [placeholder]="'service-order.reference-auto-placeholder' | translate" />
      </div>
      <div class="os-field">
        <label class="os-label os-label--info" for="os-create-installation">
          {{ 'service-order.installation-search-label' | translate }} *
          <i class="pi pi-info-circle os-label-info" tabindex="0"
            [pTooltip]="'service-order.installation-search-hint' | translate" tooltipPosition="top"
            [attr.aria-label]="'service-order.installation-search-hint' | translate"></i>
        </label>
        <!-- Aceita referência da instalação ou serial do equipamento (ver searchInstallations) -->
        <p-autoComplete inputId="os-create-installation" class="w-full" formControlName="selectedInstallation"
            [suggestions]="installationOptions" (completeMethod)="searchInstallation($event)" optionLabel="reference"
            [forceSelection]="true" [minLength]="3" [delay]="350" appendTo="body"
            [placeholder]="'service-order.installation-search-placeholder' | translate"
            [emptyMessage]="'service-order.no-results-found' | translate"
            [class.p-invalid]="form.get('selectedInstallation')?.invalid && form.get('selectedInstallation')?.dirty">
          <ng-template let-option #item>
            <span class="os-installation-option">
              <span class="os-installation-option-ref">{{ option.reference }}</span>
              @if (option.serialNumber) {
              <span class="os-installation-option-serial">{{ 'service-order.serial-label' | translate }} {{ option.serialNumber }}</span>
              }
            </span>
          </ng-template>
        </p-autoComplete>
        @if (installationFilterLoading) {
        <p-progressbar mode="indeterminate" [style]="{ height: '4px' }" />
        }
      </div>
    </div>

    <!-- Defeitos informados e Observação: mesma ordem das colunas do CSV de lote -->
    <div class="os-field">
      <label class="os-label" for="os-create-problems">{{ 'service-order.problems-label' | translate }}</label>
        <textarea pTextarea class="w-full" id="os-create-problems" formControlName="problems" [autoResize]="true"
          rows="2"></textarea>
    </div>

    <div class="os-field">
      <label class="os-label" for="os-create-notes">{{ 'service-order.notes-label' | translate }}</label>
        <textarea pTextarea class="w-full" id="os-create-notes" formControlName="notes" [autoResize]="true"
          rows="2"></textarea>
    </div>

    <div class="os-field-row">
      <div class="os-field">
        <label class="os-label" for="os-create-priority">{{ 'service-order.priority-label' | translate }} *</label>
        <select id="os-create-priority" class="os-select" formControlName="priority">
          @for (option of priorityOptions; track option.value) {
          <option [value]="option.value">{{ option.label }}</option>
          }
        </select>
      </div>
      <div class="os-field">
        <label class="os-label" for="os-create-assignee">{{ 'service-order.assigned-to' | translate }} *</label>
        <p-autoComplete inputId="os-create-assignee" class="w-full" formControlName="selectedUser"
            [suggestions]="userOptions" (completeMethod)="searchUser($event)" optionLabel="displayName"
            [forceSelection]="true" [delay]="350" appendTo="body"
            [emptyMessage]="'service-order.no-results-found' | translate"
            [class.p-invalid]="form.get('selectedUser')?.invalid && form.get('selectedUser')?.dirty">
            <ng-template let-user #item>
              <span class="os-user-option">
                <span class="os-user-option-name">{{ user.displayName }}</span>
                @if (user.username && user.username !== user.displayName) {
                <span class="os-user-option-login">{{ user.username }}</span>
                }
              </span>
            </ng-template>
          </p-autoComplete>
        @if (userFilterLoading) {
        <p-progressbar mode="indeterminate" [style]="{ height: '4px' }" />
        }
      </div>
    </div>
  </div>

  <app-service-order-installation-panel [installation]="selectedInstallation" />
  </div>

  <ng-template #footer>
    <div class="os-dialog-footer">
      @if (createLoading) {
      <p-progress-spinner strokeWidth="8" fill="transparent" animationDuration=".5s"
        [style]="{ width: '32px', height: '32px' }" />
      } @else if (discardConfirmOpen) {
      <!-- Confirmação sem overlay: é o que garante que o modal sempre consegue fechar -->
      <span class="os-discard-question">{{ 'service-order.discard-changes-title' | translate }}</span>
      <p-button [label]="'service-order.button-keep-editing' | translate" severity="secondary"
        [outlined]="true" (onClick)="dismissDiscard()" />
      <p-button [label]="'service-order.button-discard' | translate" severity="danger"
        (onClick)="confirmDiscard()" />
      } @else {
      <p-button [label]="'service-order.button-cancel' | translate" severity="secondary" (onClick)="cancel()" />
      <p-button [label]="'service-order.button-save' | translate" icon="pi pi-check" [disabled]="form.invalid"
        (onClick)="createServiceOrder()" />
      }
    </div>
  </ng-template>
</p-dialog>
